import React, { Component } from 'react';
import axios from 'axios'
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import { Button, Divider, Form } from 'semantic-ui-react'
import * as moment from 'moment';
import { base, serverIp, getOrderKey, toCurrency, pythonApiIp } from '../../../../config/constants';
import * as UiConsts from '../../../../config/UiConstants';

export class EnterShirtCost extends Component {
    constructor(props) {
        super(props);
        this.state = {
            shirtCost: '',
            loading: false
        }
    }


    enterShirtCost = (depValue) => {
        console.log("shcst1 +++++++ enterShirtCost")

        if (this.state.shirtCost != '') {

            this.setState({loading:true})

            axios.post(pythonApiIp + 'setOrderItemCost', {
                apiKey: "asdf@asdfasdf",
                order_num: this.props.order.order_num,
                itemCost: this.state.shirtCost
            })
                .then((response) =>  {
                    

                    console.log("shcst12 response:" + JSON.stringify(response.data))

                    if (response.data.result) {
                        console.log("shcst13 response:" + response.data.result)

                        var d = new Date();
                        let now = moment().format('MMMM Do, h:mm:ss a');

                        let orderUpdates = {
                            shirtCost: response.data.itemCost,
                            shirtCostDateNum: d.getTime(),
                            shirtCostRequestedTime: now,
                            shirtCostBy: this.props.user.email
                        }

                        FbUtils.updateOrder(getOrderKey(this.props.order), orderUpdates);
                        console.log("shcst15 shirtCost entered")

                        let updateText = "shirtCost:" + response.data.itemCost + " -" + this.props.user.email.substring(0, 10);
                        // let updateText = "deposit:"+this.state.depositAmount+"- "+this.props.user.email.substring(0,10);
                        FbUtils.insertUpdateText(getOrderKey(this.props.order), updateText, this.props.user.email);
                        
                        alert(response.data.message)
                    }else{
                        console.log("shcst131 response if false:" + response.data.result)
                        alert(response.data.message)
                    }
                    this.setState({loading:false, shirtCost:''})
                })
                .catch((error) =>  {
                    console.log(error);
                    this.setState({loading:false})
                    alert("error unable to set shirt cost")
                });
        }
    }

    handleTextChange = (e) => {
        console.log("dx32 e.target.name:" + e.target.name);
        console.log("dx34 e.target.value:" + e.target.value);

        this.setState({
            shirtCost: e.target.value
        })
    }




    render() {



        const payButton = this.state.shirtCost !== ''
            ? <Button color='green' onClick={this.enterShirtCost}> ENTER SHIRT COST </Button>
            : ''

        const shirtCostUI = this.props.order.shirtCost
            ? <div>
                Shirt Cost: {this.props.order.shirtCost}
            </div>
            : ''




        return (
            this.state.loading ? <UiConsts.LoadingComponent /> : <div>
                <Divider horizontal>{'ENTER SHIRT COST'}</Divider>
                <Form.Input
                    fluid
                    icon='money'
                    iconPosition='left'
                    placeholder='Shirt Cost'
                    type='text'
                    name="shirtCost"
                    value={this.state.shirtCost}
                    onChange={this.handleTextChange}
                />
                {payButton}
                {shirtCostUI}
            </div>
        )
    }
}

export default EnterShirtCost;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/EnterShirtCost/EnterShirtCost.js